module.exports = __webpack_public_path__ + "static/images/smartspot-performance-nb.06881f85f429b746a0376b348906401f.png";